import { render } from "./StockTransferForm.vue?vue&type=template&id=031774cd"
import script from "./StockTransferForm.vue?vue&type=script&lang=js"
export * from "./StockTransferForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__